var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentReceived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.099,
    height: 18.2,
    viewBox: "0 0 21.099 18.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f3293bd4f33b5dca53d8104764caec36",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20699",
    "data-name": "Path 20699",
    d: "M331.7,276.707h4.537a1.688,1.688,0,1,0,0-3.376h-4.53a5.5,5.5,0,0,1-1.779-.457l-.068-.03a7.809,7.809,0,0,0-2.624-.771,4.493,4.493,0,0,0-2.363.577.4.4,0,1,0,.414.7,3.717,3.717,0,0,1,1.944-.463,6.88,6.88,0,0,1,2.3.7l.071.031a6.119,6.119,0,0,0,2.082.523h4.548a.879.879,0,1,1,0,1.758H331.7a.4.4,0,1,0,0,.809Zm1.864-7.247c.035,0,.071,0,.107,0a1.355,1.355,0,0,0,1-.619.4.4,0,1,0-.682-.436.564.564,0,0,1-.375.248.609.609,0,0,1-.094-1.214h0a1.418,1.418,0,1,0-.209-2.829,1.356,1.356,0,0,0-1,.619.405.405,0,1,0,.683.436.564.564,0,0,1,.375-.248.609.609,0,0,1,.094,1.214h0a1.418,1.418,0,0,0,.1,2.832Z",
    transform: "translate(-322.976 -262.907)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20700",
    "data-name": "Path 20700",
    d: "M484.4,242.68a.4.4,0,0,0,.4-.4v-.621a.4.4,0,0,0-.809,0v.621A.4.4,0,0,0,484.4,242.68Zm0,4.658a.4.4,0,0,0,.4-.4v-.621a.4.4,0,0,0-.809,0v.621A.4.4,0,0,0,484.4,247.338Z",
    transform: "translate(-473.885 -240.17)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20701",
    "data-name": "Path 20701",
    d: "M311.266,168.8a4.9,4.9,0,1,0-4.9-4.9A4.905,4.905,0,0,0,311.266,168.8Zm0-9a4.093,4.093,0,1,1-4.087,4.093A4.095,4.095,0,0,1,311.266,159.809Z",
    transform: "translate(-300.747 -160)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20702",
    "data-name": "Path 20702",
    d: "M92.762,505.637a5.9,5.9,0,0,0,.941-.076,13.3,13.3,0,0,0,1.806-.5l.051-.017a16.148,16.148,0,0,0,5.337-3.3,23.5,23.5,0,0,0,2.278-2.273c.047-.056.081-.066.093-.138a1.8,1.8,0,0,0-.448-1.982,1.726,1.726,0,0,0-1.859-.347c-.324.162-.1.034-.142.065l-4.232,3.056a.4.4,0,1,0,.474.656l4.161-3a1,1,0,0,1,1.046.194.929.929,0,0,1,.215,1.064,24.021,24.021,0,0,1-2.129,2.112,15.922,15.922,0,0,1-5.051,3.135l-.053.018a12.5,12.5,0,0,1-1.676.469,5.5,5.5,0,0,1-2.665-.253l-2.571-1.134-.022-.009a13.087,13.087,0,0,0-1.9-.57,6.687,6.687,0,0,0-1.623-.07V498.5a.4.4,0,1,0-.809,0v4.725a.4.4,0,0,0,.548.379,4.162,4.162,0,0,1,1.77-.008,12.492,12.492,0,0,1,1.724.524l2.574,1.134.031.012A6.517,6.517,0,0,0,92.762,505.637Z",
    transform: "translate(-82.278 -488.438)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20703",
    "data-name": "Path 20703",
    d: "M816.674,494.152h1.713a.4.4,0,0,0,.4-.4v-7.413a.4.4,0,0,0-.4-.4h-1.713a.4.4,0,0,0-.4.4v7.413A.4.4,0,0,0,816.674,494.152Zm1.308-.809h-.9v-6.6h.9Z",
    transform: "translate(-816.27 -477.709)",
    fill: "#363636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentReceived);
export default __webpack_public_path__ + "static/media/Payment Received.c80849da6b78b6883ccc97cc7515b4df.svg";
export { ForwardRef as ReactComponent };